import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RelationCustomer from './relation-customer';
import RelationCustomerDetail from './relation-customer-detail';
import RelationCustomerUpdate from './relation-customer-update';
import RelationCustomerDeleteDialog from './relation-customer-delete-dialog';

const RelationCustomerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RelationCustomer />} />
    <Route path="new" element={<RelationCustomerUpdate />} />
    <Route path=":id">
      <Route index element={<RelationCustomerDetail />} />
      <Route path="edit" element={<RelationCustomerUpdate />} />
      <Route path="delete" element={<RelationCustomerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RelationCustomerRoutes;
